











import Vue from "vue";
import userInfoProvider from "./../services/userInfoProvider";
import store from "@/store";
import defaultLayoutConfig from '@/config/vuetifyx/defaultLayout'
import MyDefaultLayout from '@/components/layouts/MyDefaultLayout.vue'
const data = {
  data: defaultLayoutConfig
}

export default Vue.extend({
  components: {
    MyDefaultLayout
  },
  data: () => (data),
  created() {
    const token = userInfoProvider.getAccessToken();

    if (token) {
      store.dispatch("setIsLoggedin", true);
    }
  },
});
